// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ol {
  list-style-type: circle; /* Ensures numbers are used for ordered lists */
   /* Adds some space for the numbering */
}


`, "",{"version":3,"sources":["webpack://./src/Pages/Videoplay/relatedMembers.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB,EAAE,+CAA+C;GACvE,sCAAsC;AACzC","sourcesContent":["ol {\n  list-style-type: circle; /* Ensures numbers are used for ordered lists */\n   /* Adds some space for the numbering */\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
